import React from 'react'
import { useDispatch } from 'react-redux'
import $t from '../../../i18n'
import Actions from '../../../actions'
import './MhBotPreview.css'
import BotPreviewTemplate from '../../common/BotPreviewTemplate'

const MhBotPreview = () => {
  const dispatch = useDispatch()

  const onContinue = () => {
    dispatch(Actions.createAction(Actions.REDIRECT_TO_MH_BOT_INFO))
  }

  const renderTitle = () => {
    return (
      <h1 className="bot-preview-title">
        {$t('pages.getStarted.mhBotPreviewDesktop.welcome')}
        <br />
        {$t('pages.getStarted.mhBotPreviewDesktop.toOurMentalHealth')}
        <br />
        {$t('pages.getStarted.mhBotPreviewDesktop.specialtyCareService')}
      </h1>
    )
  }

  const renderMhBotPreview = () => {
    return (
      <BotPreviewTemplate
        actions={[
          {
            title: $t('pages.getStarted.mhBotPreviewDesktop.continue'),
            handleOnClick: onContinue,
          },
        ]}
        contentTitle={renderTitle()}
        contentPoints={[
          $t('pages.getStarted.mhBotPreviewDesktop.descriptionPoint1'),
          $t('pages.getStarted.mhBotPreviewDesktop.descriptionPoint2'),
          $t('pages.getStarted.mhBotPreviewDesktop.descriptionPoint3'),
          $t('pages.getStarted.mhBotPreviewDesktop.descriptionPoint4'),
          $t('pages.getStarted.mhBotPreviewDesktop.descriptionPoint5'),
        ]}
      />
    )
  }

  const renderUi = () => {
    return renderMhBotPreview()
  }

  return renderUi()
}

export default MhBotPreview
